<template>
  <div class="col-12">
    <div class="row" :class="`level-${level}`">
      <div :class="btnWidth ? btnWidth : 'col-1'">
        <div>
          <p-switch
            v-model="switchValue"
            :type="switchType"
            on-text="Да"
            off-text="Нет"
            :disabled="disabled"/>
        </div>
      </div>
      <div :class="textWidth ? textWidth : 'col-11'">
        <div class="text-muted">
          {{ data.title }}
        </div>
      </div>
      <age-restriction-question
        v-for="child in data.children"
        v-show="switchValue"
        :key="child.id"
        :init-answer="initAnswer"
        :disabled="disabled"
        :is-false="deepFalse"
        :level="level + 1"
        :data="child"
        @changeAnswer="handleChangeAnswer"/>
    </div>
  </div>
</template>

<script>
import PSwitch from '@/components/UIComponents/Switch.vue'

export default {
  name: 'AgeRestrictionQuestion',
  components: {
    PSwitch
  },
  inject: ['mq'],
  props: {
    data: Object,
    level: {
      type: Number,
      default: 1
    },
    /* eslint-disable */
    initAnswer: Array | null,
    /* eslint-enable */
    isFalse: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      switchValue: null,
      deepFalse: false
    }
  },
  computed: {
    switchType() {
      const index = this.level - 1
      return ['default', 'primary', 'info'][index]
    },
    textWidth() {
      return {
        xs: 'col-12',
        s: 'col-10',
        m: 'col-10'
      }[this.mq.current]
    },
    btnWidth() {
      return {
        xs: 'col-12',
        s: 'col-2',
        m: 'col-2'
      }[this.mq.current]
    }
  },
  watch: {
    switchValue(value, oldValue) {
      if (oldValue === null) return
      let names = [this.data.name]
      if (value === false) {
        const getChildrenArray = data => {
          let result = []
          if (data.children.length) {
            for (const child of data.children) {
              result.push(child.name)
              result = result.concat(getChildrenArray(child))
            }
          }
          return result
        }
        names = names.concat(getChildrenArray(this.data))
      }
      this.deepFalse = !value
      this.$emit('changeAnswer', {
        value,
        names
      })
    },
    isFalse(value) {
      if (!value) return
      this.switchValue = false
      this.deepFalse = true
    }
  },
  methods: {
    handleChangeAnswer(payload) {
      this.$emit('changeAnswer', payload)
    }
  },
  beforeMount() {
    this.switchValue = this.initAnswer ? this.initAnswer.includes(this.data.name) : false
  }
}
</script>

<style scoped>

</style>
